import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Property1Default from "../components/Property1Default";
import SizeMediumStateDefaultSt1 from "../components/SizeMediumStateDefaultSt1";
import SizeMediumStateDefaultSt from "../components/SizeMediumStateDefaultSt";
import CompanyLinkedInStyleColourIcon from "../components/CompanyLinkedInStyleColourIcon";
import Footer from "../components/Footer";
import styles from "./About.module.css";

const About = () => {
  const navigate = useNavigate();

  const onButtonClick = useCallback(() => {
    const anchor = document.querySelector(
      "[data-scroll-to='contactFormContainer']"
    );
    if (anchor) {
      anchor.scrollIntoView({ block: "start" });
    }
  }, []);

  const onAboutMeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutMeContainer2Click = useCallback(() => {
    navigate("/services");
  }, [navigate]);

  const onAboutMeContainer3Click = useCallback(() => {
    navigate("/staff");
  }, [navigate]);

  const onFrameContainer1Click = useCallback(() => {
    const anchor = document.querySelector(
      "[data-scroll-to='contactFormContainer']"
    );
    if (anchor) {
      anchor.scrollIntoView({ block: "start" });
    }
  }, []);

  return (
    <div className={styles.about}>
      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles.medicalIconiPhysicalTherapParent}>
            <img
              className={styles.medicalIconiPhysicalTherap}
              alt=""
              src="/medicaliconiphysicaltherapy1.svg"
            />
            <div className={styles.logo}>
              <img className={styles.logo1Icon} alt="" src="/logo-1.svg" />
              <b className={styles.personal}>
                <p className={styles.jJPhysical}>{`J &J Physical`}</p>
                <p className={styles.jJPhysical}>Therapy</p>
              </b>
            </div>
          </div>
          <div className={styles.taskbaar}>
            <div className={styles.aboutMe} onClick={onAboutMeContainerClick}>
              <div className={styles.aboutMe1}>Home</div>
            </div>
            <Property1Default
              sectionTitle="About"
              property1DefaultBorderRadius="15px"
              property1DefaultBackgroundColor="rgba(93, 37, 214, 0.63)"
              property1DefaultBoxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              property1DefaultPadding="10px"
              property1DefaultBoxSizing="border-box"
            />
            <div className={styles.aboutMe} onClick={onAboutMeContainer2Click}>
              <div className={styles.aboutMe1}>Services</div>
            </div>
            <div className={styles.aboutMe} onClick={onAboutMeContainer3Click}>
              <div className={styles.aboutMe1}>Our Staff</div>
            </div>
          </div>
          <div
            className={styles.containerInner}
            onClick={onFrameContainer1Click}
          >
            <div className={styles.buttonParent}>
              <SizeMediumStateDefaultSt1
                linkText="Contact Us"
                showDownloadIcon={false}
                sizeMediumStateDefaultStCursor="pointer"
                sizeMediumStateDefaultStBorder="none"
                sizeMediumStateDefaultStBackgroundColor="rgba(0, 0, 0, 0)"
                sizeMediumStateDefaultStHeight="26px"
                sizeMediumStateDefaultStJustifyContent="flex-start"
                sizeMediumStateDefaultStPadding="0"
                sizeMediumStateDefaultStBoxSizing="unset"
                sizeMediumStateDefaultStWidth="122px"
                sizeMediumStateDefaultStZIndex="0"
                resumeDisplay="inline-block"
                onButtonContainerClick={onButtonClick}
              />
              <img className={styles.vectorIcon} alt="" src="/vector.svg" />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.testimonial}>
        <div className={styles.testimonialInner}>
          <div className={styles.testimonialInner}>
            <div className={styles.aboutUsParent}>
              <b className={styles.aboutUs}>About Us</b>
              <div className={styles.loremIpsumDolor}>
                Lorem ipsum dolor sit amet consectetur. Quis lorem consequat est
                varius nulla imperdiet pulvinar. Faucibus nibh mi leo fames
                tortor ultrices felis. Facilisis nunc hac sed lectus vehicula
                massa dui faucibus lacus. Euismod orci quis mauris purus
                accumsan justo nunc velit sagittis. Porttitor tempor commodo
                vitae tristique montes erat aliquam id est. Blandit tristique
                sagittis euismod et.
              </div>
            </div>
            <div className={styles.groupParent}>
              <img className={styles.frameChild} alt="" src="/group-20.svg" />
              <img
                className={styles.samMoghadamKhamseh0sa8d74ioIcon}
                alt=""
                src="/sammoghadamkhamseh0sa8d74iodiunsplash-3@2x.png"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.moreAboutUsWrapper}>
        <b className={styles.moreAboutUs}>More about us</b>
      </div>
      <div className={styles.frameGroup}>
        <div className={styles.loremIpsumDolorSitAmetConWrapper}>
          <div className={styles.loremIpsumDolorContainer}>
            <p className={styles.jJPhysical}>
              Lorem ipsum dolor sit amet consectetur. Quis lorem consequat est
              varius nulla imperdiet pulvinar. Faucibus nibh mi leo fames tortor
              ultrices felis. Facilisis nunc hac sed lectus vehicula massa dui
              faucibus lacus. Euismod orci quis mauris purus accumsan justo nunc
              velit sagittis. Porttitor tempor commodo vitae tristique montes
              erat aliquam id est. Blandit tristique sagittis euismod et. Quis
              non integer amet tincidunt aenean.
            </p>
            <p className={styles.jJPhysical}>&nbsp;</p>
            <p className={styles.jJPhysical}>
              Lorem ipsum dolor sit amet consectetur. Quis lorem consequat est
              varius nulla imperdiet pulvinar. Faucibus nibh mi leo fames tortor
              ultrices felis. Facilisis nunc hac sed lectus vehicula massa dui
              faucibus lacus. Euismod orci quis mauris purus accumsan justo nunc
              velit sagittis. Porttitor tempor commodo vitae tristique montes
              erat aliquam id est. Blandit tristique sagittis euismod et. Quis
              non integer amet tincidunt aenean.
            </p>
            <p className={styles.jJPhysical}>&nbsp;</p>
            <p className={styles.jJPhysical}>
              Lorem ipsum dolor sit amet consectetur. Quis lorem consequat est
              varius nulla imperdiet pulvinar. Faucibus nibh mi leo fames tortor
              ultrices felis. Facilisis nunc hac sed lectus vehicula massa dui
              faucibus lacus. Euismod orci quis mauris purus accumsan justo nunc
              velit sagittis. Porttitor tempor commodo vitae tristique montes
              erat aliquam id est. Blandit tristique sagittis euismod et. Quis
              non integer amet tincidunt aenean.
            </p>
          </div>
        </div>
        <div className={styles.frameContainer}>
          <div className={styles.rectangleWrapper}>
            <img
              className={styles.frameItem}
              alt=""
              src="/rectangle-15@2x.png"
            />
          </div>
          <div className={styles.rectangleContainer}>
            <img
              className={styles.frameInner}
              alt=""
              src="/rectangle-16@2x.png"
            />
          </div>
        </div>
      </div>
      <div className={styles.contactUsWrapper}>
        <div className={styles.contactUs}>CONTACT US</div>
      </div>
      <div className={styles.contactForm} data-scroll-to="contactFormContainer">
        <div className={styles.frameDiv}>
          <div className={styles.jjPhysicalTherapyParent}>
            <div className={styles.rectangleParent}>
              <input
                className={styles.rectangleInput}
                placeholder="FULL NAME"
                type="text"
              />
              <input
                className={styles.rectangleInput}
                placeholder="PHONE"
                type="text"
              />
              <input
                className={styles.rectangleInput}
                placeholder="EMAIL"
                type="text"
              />
              <input
                className={styles.rectangleInput}
                placeholder="MESSAGE"
                type="text"
              />
            </div>
            <div className={styles.button}>
              <SizeMediumStateDefaultSt
                linkText="Contact Us"
                sizeMediumStateDefaultStCursor="pointer"
                sizeMediumStateDefaultStBorder="none"
                resumeDisplay="inline-block"
              />
              <div className={styles.facebookParent}>
                <CompanyLinkedInStyleColourIcon
                  dimensionLabel="/facebook.svg"
                  companyLinkedInStyleColouWidth="59px"
                  companyLinkedInStyleColouHeight="59px"
                  companyLinkedInStyleColouPosition="relative"
                  companyLinkedInStyleColouFlexShrink="0"
                />
                <CompanyLinkedInStyleColourIcon
                  dimensionLabel="/tweet.svg"
                  companyLinkedInStyleColouWidth="59px"
                  companyLinkedInStyleColouHeight="59px"
                  companyLinkedInStyleColouPosition="relative"
                  companyLinkedInStyleColouFlexShrink="0"
                />
                <CompanyLinkedInStyleColourIcon
                  dimensionLabel="/mediaicon.svg"
                  companyLinkedInStyleColouWidth="59px"
                  companyLinkedInStyleColouHeight="59px"
                  companyLinkedInStyleColouPosition="relative"
                  companyLinkedInStyleColouFlexShrink="0"
                />
                <CompanyLinkedInStyleColourIcon
                  dimensionLabel="/linden.svg"
                  companyLinkedInStyleColouWidth="59px"
                  companyLinkedInStyleColouHeight="59px"
                  companyLinkedInStyleColouPosition="relative"
                  companyLinkedInStyleColouFlexShrink="0"
                />
              </div>
              <div className={styles.buttonChild} />
            </div>
          </div>
          <div className={styles.column}>
            <div className={styles.text}>
              <div className={styles.frameParent2}>
                <div className={styles.frameParent3}>
                  <div className={styles.frameWrapper}>
                    <div className={styles.medicalIconiPhysicalTherapGroup}>
                      <img
                        className={styles.medicalIconiPhysicalTherap1}
                        alt=""
                        src="/medicaliconiphysicaltherapy11.svg"
                      />
                      <div className={styles.logo}>
                        <img
                          className={styles.logo1Icon}
                          alt=""
                          src="/logo-1.svg"
                        />
                        <b className={styles.personal}>
                          <p className={styles.jJPhysical}>{`J &J Physical`}</p>
                          <p className={styles.jJPhysical}>Therapy</p>
                        </b>
                      </div>
                    </div>
                  </div>
                  <div className={styles.oneOnOneCustomizedContainer}>
                    <p className={styles.jJPhysical}>One on One</p>
                    <p className={styles.jJPhysical}>Customized Treatment</p>
                  </div>
                </div>
                <div className={styles.youAreNotContainer}>
                  <p
                    className={styles.jJPhysical}
                  >{`You are not alone! We are here to help you get `}</p>
                  <p className={styles.jJPhysical}>{`back on your feet. `}</p>
                </div>
              </div>
              <div className={styles.jjphysicaltherapysomemailcoParent}>
                <div
                  className={styles.jjphysicaltherapysomemailco}
                >{`J&JPhysicalTherapy@somemail.com`}</div>
                <div className={styles.jjphysicaltherapysomemailco}>
                  607-000-0101
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frameParent4}>
        <div className={styles.frameParent5}>
          <div className={styles.jjPhysicalTherapyParent}>
            <div className={styles.jjPhysicalTherapyContainer}>
              <span className={styles.jjPhysical}>{`J&J Physical `}</span>
              <span>Therapy</span>
            </div>
            <div className={styles.fromPainTo}>
              From pain to progress, we're with you every step.
            </div>
          </div>
          <div className={styles.copyrightJjPhysicalTherapyWrapper}>
            <div
              className={styles.copyrightJjPhysical}
            >{` © Copyright j&j physical  therapy  inc.`}</div>
          </div>
        </div>
        <div className={styles.frameParent6}>
          <div className={styles.helpParent}>
            <div className={styles.help}>Help</div>
            <div className={styles.supportWebinarPlatformsContainer}>
              <p className={styles.jJPhysical}>Support</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Webinar Platforms</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Consult</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Video Chats</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Features</div>
            <div className={styles.ugentCareSpecialContainer}>
              <p className={styles.jJPhysical}>Ugent Care</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Special Programs</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>File Sharing</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Company</div>
            <div className={styles.aboutUsCareersContainer}>
              <p className={styles.jJPhysical}>About Us</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Careers</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Contact Us</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.contactUs2}>Contact Us</div>
            <div className={styles.junesjjtherapycom1800000}>
              <p className={styles.jJPhysical}>JuneS@jjtherapy.com</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>1-800-000-000</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>2384 W. Lane</p>
              <p className={styles.jJPhysical}>Somewhere, NY 10800</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
